import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import { SeatingDetails } from 'features/seating-chart';
import { AlertNotice } from 'shared/components';

class RoomSeatingDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      room: props.room,
      errors: {},
    };

    this.child = React.createRef();
    this.onContinue = this.onContinue.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.room && this.props.room.id && prevProps.room !== this.props.room) {
      this.setState({
        room: this.props.room,
      });
    }
  }

  onContinue() {
    if (this.child.current && this.child.current.onSubmit) {
      const roomContent = this.child.current.onSubmit();
      if (roomContent && !isEmpty(roomContent)) {
        this.props.onContinue(roomContent);
      }
      return;
    }
  }

  render() {
    const { room } = this.state;
    const { locations, errorRoom } = this.props;

    const location = locations.find((loc) => loc.id === room.locationEvent.locationId);

    return (
      !isEmpty(room) &&
      !room.loading && (
        <div className="room-information">
          <h4 className="mb-3">{this.props.t('roomBuilder.seatingDetailsTitle')}</h4>
          <p className="mb-1">{room.name}</p>
          {location && (
            <p className="mb-4">
              <span>{location.name}</span>
              {location.area && location.area.length > 0 && <span>, {location.area}</span>}
            </p>
          )}
          <SeatingDetails ref={this.child} room={room} />
          {!isEmpty(errorRoom) && (
            <div className="mt-3">
              <AlertNotice message={errorRoom.message} type="error" />
            </div>
          )}
          <div className="buttons-container w-100">
            <button type="button" className="btn btn-outline w-50" onClick={this.props.onBack}>
              {this.props.t('common.labels.back')}
            </button>
            <button type="button" className="btn btn-primary w-50" onClick={this.onContinue}>
              {this.props.t('common.labels.continue')}
            </button>
          </div>
        </div>
      )
    );
  }
}

RoomSeatingDetails.propTypes = {
  room: PropTypes.shape({}).isRequired,
  onBack: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(RoomSeatingDetails);
